module.exports = __webpack_public_path__ + "static/yang_outline-95b9a80a23d0cbb04ce27c0f32848a1a.png";